import { action, actionOn, thunk } from "easy-peasy";
import axios from '../services/axios';

const relationTypesInitialState = {
    allRelationTypes: [],
    isFetchingAllRelationTypes: false,
    isUpdateNecessary: true,
    initialFetchDone: false,
}

const relationTypes = {
    ...relationTypesInitialState,

    onGlobalResetCalled: actionOn(
        (actions, storeActions) => [
            storeActions.resetStore.performReset,
        ],
        (state, target) => {
            const [performReset] = target.resolvedTargets;

            if (target.type === performReset) {
                ({
                    allRelationTypes: state.allRelationTypes,
                    isFetchingAllRelationTypes: state.isFetchingAllRelationTypes,
                    isUpdateNecessary: state.isUpdateNecessary,
                    initialFetchDone: state.initialFetchDone
                } = relationTypesInitialState);
            }
        }
    ),

    setAllRelationTypes: action((state, payload) => {
        state.allRelationTypes = payload;
    }),

    setIsFetchingAllRelationTypes: action((state, payload) => {
        state.isFetchingAllRelationTypes = payload;
    }),

    setIsUpdateNecessary: action((state, payload) => {
        state.isUpdateNecessary = payload;
    }),

    setInitialFetchDone: action((state, payload) => {
        state.initialFetchDone = payload;
    }),

    fetchRelationTypes: thunk((actions, payload, helpers) => {
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const { isFetchingAllRelationTypes, isUpdateNecessary } = helpers.getState();

        const getRelationTypesUrl = ACTIONS?.clientRelationTypes?.readAll?.url;
        if (getRelationTypesUrl && !isFetchingAllRelationTypes && isUpdateNecessary) {
            actions.setIsFetchingAllRelationTypes(true);
            return axios.get(getRelationTypesUrl)
                .then((result) => {
                    actions.setAllRelationTypes(result);
                    actions.setIsFetchingAllRelationTypes(false);
                    actions.setIsUpdateNecessary(false);
                    return result;
                })
                .catch(error => {
                    return Promise.reject(error);
                });
        } else {
            return Promise.resolve();
        }
    }),

    addRelationType: action((state, payload) => {
        for (const element of payload) {
            const existingRelationTypes = state.allRelationTypes.find(relationType => relationType?.uniqueId === element.uniqueId);
            if (existingRelationTypes === undefined) {
                state.allRelationTypes.push(element);
            }
        }
    }),

    createRelationType: thunk((actions, payload, helpers) => {
        const data = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const createRelationTypeUrl = ACTIONS?.clientRelationTypes?.create?.url;

        return axios.post(createRelationTypeUrl, data)
            .then((result) => {
                actions.addRelationType(result);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    updateRelationTypeProps: thunk((actions, payload, helpers) => {
        const allRelationTypes = helpers.getState().allRelationTypes;

        const newAllRelationTypes = allRelationTypes
            .map(relationType => {
                const newRelationType = payload?.find(rT => relationType.uniqueId === rT.uniqueId);
                return { ...relationType, ...newRelationType }
            });

        actions.setAllRelationTypes(newAllRelationTypes);
    }),

    updateRelationType: thunk((actions, payload, helpers) => {
        const { data, uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;
        const updateRelationTypeUrl = ACTIONS?.clientRelationTypes?.update?.url?.replace('uniqueId', uniqueId);

        return axios.post(updateRelationTypeUrl, data)
            .then((result) => {
                actions.updateRelationTypeProps(result);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

    removeRelationType: action((state, payload) => {
        state.allRelationTypes = state.allRelationTypes.filter(relationType => relationType?.uniqueId !== payload);
    }),

    deleteRelationType: thunk((actions, payload, helpers) => {
        const { uniqueId } = payload;
        const { apiData: { ACTIONS } } = helpers.getStoreState().actionSlugs;

        const deleteRelationTypeUrl = ACTIONS?.clientRelationTypes?.delete?.url?.replace('uniqueId', uniqueId);
        const data = { csrfToken: ACTIONS?.clientRelationTypes?.delete?.csrfToken };

        return axios.post(deleteRelationTypeUrl, data)
            .then((result) => {
                actions.removeRelationType(uniqueId);
                return result;
            })
            .catch(error => {
                return Promise.reject(error);
            });
    }),

}

export default relationTypes;